import React, { useEffect, useState } from "react";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import { Formik, Form } from "formik";
import CustomInput from "../../../CustomComponent/custom_input";
import CustomSelect from "../../../CustomComponent/custom_select";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { useNavigate, useParams } from "react-router-dom";
import { StructureUtilizationInfo } from "../../../SchemaInfo/info";
import LoadingPage from "../../../Components/layouts/loading";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { StructureUtilizationSchema } from "../../../Schemas/clients/structure_utilization_schema";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { getId } from "../../../Components/Functions/word.fun";
import StepRoutes from "../../../Routes/steps_routes";

import { FcSms, FcTemplate } from "react-icons/fc";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const EditStructureUtilization = () => {
  const [loading, setLoading] = useState(false);
  const [structureInfo, setStructureInfo] = useState(StructureUtilizationInfo);
  const [projects, setProjects] = useState([]);
  let { id } = useParams();

  const navigate = useNavigate();
  const handelSubmit = (values, actions) => {
    let formData = new FormData();
    for (let key in values) {
      formData.append(key, values[key]);
    }
    const headers = { "Content-Type": "multipart/form-data" };
    setLoading(true);
    performRequest(
      "PATCH",
      `/structureUtilization/updateStructure/${id}`,
      formData,
      headers
    )
      .then((res) => {
        if (res.status === 200) {
          Toast(
            "success",
            "Update assessement of structure for utilization successfully!"
          );
          navigate(`/view-structure-utilization/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    performRequest("GET", "/siteInspection/getAllProjects")
      .then((res) => setProjects(res.data))
      .catch((err) => CustomErrorResponse(err));
  }, []);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/structureUtilization/getStructure/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setStructureInfo(res.data);
        } else {
          Toast("error", "Error while getting client expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        // Toast("error", "Server Error!");
        // console.error(err);
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcTemplate className="fs-2  me-1" /> Edit assessement of
                  structure for utilization
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-md-4">
                <div className="btn-list justify-content-end"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="py-2">
              <div className="card">
                <div className="card-header">
                  <h2 className="page-title">
                    Edit assessement of structure for utilization
                  </h2>
                </div>
                <Formik
                  initialValues={structureInfo}
                  validationSchema={StructureUtilizationSchema}
                  onSubmit={handelSubmit}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Project
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="projectName">
                              <option value="">Select</option>
                              {projects &&
                                projects?.map((pro) => {
                                  return (
                                    <option
                                      key={pro.cpNumber}
                                      value={pro.clientName}
                                    >
                                      {pro.clientName}
                                    </option>
                                  );
                                })}
                            </CustomSelect>

                            {props.touched.projectName &&
                              props.errors.projectName && (
                                <p className="text-danger">
                                  {props.errors.projectName}
                                </p>
                              )}
                          </div>
                        </div>
                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label required col-3">
                        Length of structure (meter)
                      </label>

                      <div className="w-100 col">
                        <CustomInput name="lengthOfStru" type="text" />
                        {props.touched.lengthOfStru &&
                          props.errors.lengthOfStru && (
                            <p className="text-danger">
                              {props.errors.lengthOfStru}
                            </p>
                          )}
                      </div>
                    </div> */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label required">
                            Total length (including hocky area)
                          </label>
                          <div className="w-100 col">
                            <CustomInput name="totalenHocky" type="text" />
                            {props.touched.totalenHocky &&
                              props.errors.totalenHocky && (
                                <p className="text-danger">
                                  {props.errors.totalenHocky}
                                </p>
                              )}
                          </div>
                        </div>
                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 required">
                        Width of structure (meter)
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="widthOfStru" />
                        {props.touched.widthOfStru &&
                          props.errors.widthOfStru && (
                            <p className="text-danger">
                              {props.errors.widthOfStru}
                            </p>
                          )}
                      </div>
                    </div> */}
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Total Width (including hocky area)
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="totawidHocky" />
                            {props.touched.totawidHocky &&
                              props.errors.totawidHocky && (
                                <p className="text-danger">
                                  {props.errors.totawidHocky}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Side height of structure
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="sideHeight" />
                            {props.touched.sideHeight &&
                              props.errors.sideHeight && (
                                <p className="text-danger">
                                  {props.errors.sideHeight}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Center height of structure(Big Column location)
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="centerHeight" />
                            {props.touched.centerHeight &&
                              props.errors.centerHeight && (
                                <p className="text-danger">
                                  {props.errors.centerHeight}
                                </p>
                              )}
                          </div>
                        </div>
                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Big column location
                      </label>
                      <div className="w-100 col">
                        <CustomInput type="text" name="bigColumnLoc" />
                        {props.touched.bigColumnLoc &&
                          props.errors.bigColumnLoc && (
                            <p className="text-danger">
                              {props.errors.bigColumnLoc}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Number of gutters
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="gutterNum" />
                            {props.touched.gutterNum &&
                              props.errors.gutterNum && (
                                <p className="text-danger">
                                  {props.errors.gutterNum}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Gutter length of structure
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="gutterLen" />
                            {props.touched.gutterLen &&
                              props.errors.gutterLen && (
                                <p className="text-danger">
                                  {props.errors.gutterLen}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label  col-3">
                            Big column center of join image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="bigColImg"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "bigColImg",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.bigColImg &&
                              props.errors.bigColImg && (
                                <p className="text-danger">
                                  {props.errors.bigColImg}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Side column join photo
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideColImg"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideColImg",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideColImg &&
                              props.errors.sideColImg && (
                                <p className="text-danger">
                                  {props.errors.sideColImg}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            North side hockey to column distance (in meters)
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="northSideHock" />
                            {props.touched.northSideHock &&
                              props.errors.northSideHock && (
                                <p className="text-danger">
                                  {props.errors.northSideHock}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            South side hockey to column distance (in meters)
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="southSideHock" />
                            {props.touched.southSideHock &&
                              props.errors.southSideHock && (
                                <p className="text-danger">
                                  {props.errors.southSideHock}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            East side hockey to column distance (in meters)
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="eastSideHock" />
                            {props.touched.eastSideHock &&
                              props.errors.eastSideHock && (
                                <p className="text-danger">
                                  {props.errors.eastSideHock}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            West side hockey to column distance (in meters)
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="westSideHock" />
                            {props.touched.westSideHock &&
                              props.errors.westSideHock && (
                                <p className="text-danger">
                                  {props.errors.westSideHock}
                                </p>
                              )}
                          </div>
                        </div>
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Hockey to column join counts
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              type="text"
                              name="hockeyToColoumnCount"
                            />
                            {props.touched.hockeyToColoumnCount &&
                              props.errors.hockeyToColoumnCount && (
                                <p className="text-danger">
                                  {props.errors.hockeyToColoumnCount}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Length of the entry cabin
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              type="text"
                              name="lengthOfEntryCabin"
                            />
                            {props.touched.lengthOfEntryCabin &&
                              props.errors.lengthOfEntryCabin && (
                                <p className="text-danger">
                                  {props.errors.lengthOfEntryCabin}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Width of the entry cabin
                          </label>
                          <div className="w-100 col">
                            <CustomInput type="text" name="widthOfEntryCabin" />
                            {props.touched.widthOfEntryCabin &&
                              props.errors.widthOfEntryCabin && (
                                <p className="text-danger">
                                  {props.errors.widthOfEntryCabin}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Height of the entry cabin
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              type="text"
                              name="heightOfEntryCabin"
                            />
                            {props.touched.heightOfEntryCabin &&
                              props.errors.heightOfEntryCabin && (
                                <p className="text-danger">
                                  {props.errors.heightOfEntryCabin}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Entry cabin direction
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="entryCabinDirection"
                            >
                              <option value="">Select</option>
                              <option value="East">East</option>
                              <option value="West">West</option>
                              <option value="North">North</option>
                              <option value="South">South</option>
                            </CustomSelect>

                            {props.touched.entryCabinDirection &&
                              props.errors.entryCabinDirection && (
                                <p className="text-danger">
                                  {props.errors.entryCabinDirection}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Number of doors to entry cabin
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              type="text"
                              name="numOfDoorsEntryCabin"
                            />
                            {props.touched.numOfDoorsEntryCabin &&
                              props.errors.numOfDoorsEntryCabin && (
                                <p className="text-danger">
                                  {props.errors.numOfDoorsEntryCabin}
                                </p>
                              )}
                          </div>
                        </div>

                        <hr></hr>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side footer apron status direction(East)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideFooterDirectionEast"
                        />
                        {props.touched.sideFooterDirectionEast &&
                          props.errors.sideFooterDirectionEast && (
                            <p className="text-danger">
                              {props.errors.sideFooterDirectionEast}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Side footer apron status(East)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideFooterApronStatusEast"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideFooterApronStatusEast &&
                              props.errors.sideFooterApronStatusEast && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusEast}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Side footer apron status(East) Image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideFooterApronStatusImgEast"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideFooterApronStatusImgEast",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideFooterApronStatusImgEast &&
                              props.errors.sideFooterApronStatusImgEast && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusImgEast}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side footer apron status direction(West)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideFooterDirectionWest"
                        />
                        {props.touched.sideFooterDirectionWest &&
                          props.errors.sideFooterDirectionWest && (
                            <p className="text-danger">
                              {props.errors.sideFooterDirectionWest}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Side footer apron status(West)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideFooterApronStatusWest"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideFooterApronStatusWest &&
                              props.errors.sideFooterApronStatusWest && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusWest}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Side footer apron status(West) Image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideFooterApronStatusImgWest"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideFooterApronStatusImgWest",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideFooterApronStatusImgWest &&
                              props.errors.sideFooterApronStatusImgWest && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusImgWest}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side footer apron status direction(North)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideFooterDirectionNorth"
                        />
                        {props.touched.sideFooterDirectionNorth &&
                          props.errors.sideFooterDirectionNorth && (
                            <p className="text-danger">
                              {props.errors.sideFooterDirectionNorth}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Side footer apron status(North)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideFooterApronStatusNorth"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideFooterApronStatusNorth &&
                              props.errors.sideFooterApronStatusNorth && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusNorth}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Side footer apron status(North) Image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideFooterApronStatusImgNorth"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideFooterApronStatusImgNorth",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideFooterApronStatusImgNorth &&
                              props.errors.sideFooterApronStatusImgNorth && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusImgNorth}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side footer apron status direction(South)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideFooterDirectionSouth"
                        />
                        {props.touched.sideFooterDirectionSouth &&
                          props.errors.sideFooterDirectionSouth && (
                            <p className="text-danger">
                              {props.errors.sideFooterDirectionSouth}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Side footer apron status(South)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideFooterApronStatusSouth"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideFooterApronStatusSouth &&
                              props.errors.sideFooterApronStatusSouth && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusSouth}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Side footer apron status(South) Image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideFooterApronStatusImgSouth"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideFooterApronStatusImgSouth",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideFooterApronStatusImgSouth &&
                              props.errors.sideFooterApronStatusImgSouth && (
                                <p className="text-danger">
                                  {props.errors.sideFooterApronStatusImgSouth}
                                </p>
                              )}
                          </div>
                        </div>
                        <hr></hr>
                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side insectnet apron status direction(East)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideinsectNetDirectionEast"
                        />
                        {props.touched.sideinsectNetDirectionEast &&
                          props.errors.sideinsectNetDirectionEast && (
                            <p className="text-danger">
                              {props.errors.sideinsectNetDirectionEast}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Insectnet status(East)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideinsectNetApronStatusEast"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideinsectNetApronStatusEast &&
                              props.errors.sideinsectNetApronStatusEast && (
                                <p className="text-danger">
                                  {props.errors.sideinsectNetApronStatusEast}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Insectnet Image(East)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideinsectNetApronStatusImgEast"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideinsectNetApronStatusImgEast",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideinsectNetApronStatusImgEast &&
                              props.errors.sideinsectNetApronStatusImgEast && (
                                <p className="text-danger">
                                  {props.errors.sideinsectNetApronStatusImgEast}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side insectnet apron status direction(West)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideinsectNetDirectionWest"
                        />
                        {props.touched.sideinsectNetDirectionWest &&
                          props.errors.sideinsectNetDirectionWest && (
                            <p className="text-danger">
                              {props.errors.sideinsectNetDirectionWest}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Insectnet status(West)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideinsectNetApronStatusWest"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideinsectNetApronStatusWest &&
                              props.errors.sideinsectNetApronStatusWest && (
                                <p className="text-danger">
                                  {props.errors.sideinsectNetApronStatusWest}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Insectnet Image(West)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideinsectNetApronStatusImgWest"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideinsectNetApronStatusImgWest",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideinsectNetApronStatusImgWest &&
                              props.errors.sideinsectNetApronStatusImgWest && (
                                <p className="text-danger">
                                  {props.errors.sideinsectNetApronStatusImgWest}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side insectnet apron status direction(North)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideinsectNetDirectionNorth"
                        />
                        {props.touched.sideinsectNetDirectionNorth &&
                          props.errors.sideinsectNetDirectionNorth && (
                            <p className="text-danger">
                              {props.errors.sideinsectNetDirectionNorth}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Insectnet status(North)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideinsectNetApronStatusNorth"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideinsectNetApronStatusNorth &&
                              props.errors.sideinsectNetApronStatusNorth && (
                                <p className="text-danger">
                                  {props.errors.sideinsectNetApronStatusNorth}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Insectnet Image(North)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideinsectNetApronStatusImgNorth"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideinsectNetApronStatusImgNorth",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideinsectNetApronStatusImgNorth &&
                              props.errors.sideinsectNetApronStatusImgNorth && (
                                <p className="text-danger">
                                  {
                                    props.errors
                                      .sideinsectNetApronStatusImgNorth
                                  }
                                </p>
                              )}
                          </div>
                        </div>
                        {/* 
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side insectnet apron status direction(South)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sideinsectNetDirectionSouth"
                        />
                        {props.touched.sideinsectNetDirectionSouth &&
                          props.errors.sideinsectNetDirectionSouth && (
                            <p className="text-danger">
                              {props.errors.sideinsectNetDirectionSouth}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Insectnet status(South)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sideinsectNetApronStatusSouth"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sideinsectNetApronStatusSouth &&
                              props.errors.sideinsectNetApronStatusSouth && (
                                <p className="text-danger">
                                  {props.errors.sideinsectNetApronStatusSouth}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Insectnet Image(South)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sideinsectNetApronStatusImgSouth"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sideinsectNetApronStatusImgSouth",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sideinsectNetApronStatusImgSouth &&
                              props.errors.sideinsectNetApronStatusImgSouth && (
                                <p className="text-danger">
                                  {
                                    props.errors
                                      .sideinsectNetApronStatusImgSouth
                                  }
                                </p>
                              )}
                          </div>
                        </div>
                        <hr></hr>
                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side polyfilm apron status direction(East)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sidePolyfieldDirectionEast"
                        />
                        {props.touched.sidePolyfieldDirectionEast &&
                          props.errors.sidePolyfieldDirectionEast && (
                            <p className="text-danger">
                              {props.errors.sidePolyfieldDirectionEast}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Polyfilm status(East)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sidePolyfieldApronStatusEast"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sidePolyfieldApronStatusEast &&
                              props.errors.sidePolyfieldApronStatusEast && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronStatusEast}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Polyfilm Image(East)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sidePolyfieldApronImgEast"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sidePolyfieldApronImgEast",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sidePolyfieldApronImgEast &&
                              props.errors.sidePolyfieldApronImgEast && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronImgEast}
                                </p>
                              )}
                          </div>
                        </div>
                        {/* 
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side polyfilm apron status direction(West)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sidePolyfieldDirectionWest"
                        />
                        {props.touched.sidePolyfieldDirectionWest &&
                          props.errors.sidePolyfieldDirectionWest && (
                            <p className="text-danger">
                              {props.errors.sidePolyfieldDirectionWest}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Polyfilm status(West)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sidePolyfieldApronStatusWest"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sidePolyfieldApronStatusWest &&
                              props.errors.sidePolyfieldApronStatusWest && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronStatusWest}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            polyfilm Image(West)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sidePolyfieldApronImgWest"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sidePolyfieldApronImgWest",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sidePolyfieldApronImgWest &&
                              props.errors.sidePolyfieldApronImgWest && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronImgWest}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side polyfilm apron status direction(North)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sidePolyfieldDirectionNorth"
                        />
                        {props.touched.sidePolyfieldDirectionNorth &&
                          props.errors.sidePolyfieldDirectionNorth && (
                            <p className="text-danger">
                              {props.errors.sidePolyfieldDirectionNorth}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Polyfilm status(North)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sidePolyfieldApronStatusNorth"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sidePolyfieldApronStatusNorth &&
                              props.errors.sidePolyfieldApronStatusNorth && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronStatusNorth}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Polyfilm Image(North)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sidePolyfieldApronImgNorth"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sidePolyfieldApronImgNorth",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sidePolyfieldApronImgNorth &&
                              props.errors.sidePolyfieldApronImgNorth && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronImgNorth}
                                </p>
                              )}
                          </div>
                        </div>

                        {/* <div className="mb-3 row">
                      <label className="w-25 form-label col-3 ">
                        Side polyfilm apron status direction(South)
                      </label>
                      <div className="w-100 col">
                        <CustomInput
                          type="text"
                          name="sidePolyfieldDirectionSouth"
                        />
                        {props.touched.sidePolyfieldDirectionSouth &&
                          props.errors.sidePolyfieldDirectionSouth && (
                            <p className="text-danger">
                              {props.errors.sidePolyfieldDirectionSouth}
                            </p>
                          )}
                      </div>
                    </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Polyfilm status(South)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="sidePolyfieldApronStatusSouth"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.sidePolyfieldApronStatusSouth &&
                              props.errors.sidePolyfieldApronStatusSouth && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronStatusSouth}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Polyfilm Image(South)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="sidePolyfieldApronImgSouth"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "sidePolyfieldApronImgSouth",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.sidePolyfieldApronImgSouth &&
                              props.errors.sidePolyfieldApronImgSouth && (
                                <p className="text-danger">
                                  {props.errors.sidePolyfieldApronImgSouth}
                                </p>
                              )}
                          </div>
                        </div>

                        <hr></hr>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Secondary Shade Net(shadow Net)
                          </label>
                          <div className="w-100 col">
                            <CustomSelect
                              type="text"
                              name="secoundaryShadowNet"
                            >
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.secoundaryShadowNet &&
                              props.errors.secoundaryShadowNet && (
                                <p className="text-danger">
                                  {props.errors.secoundaryShadowNet}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Secondary Shade Net(shadow Net) Image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="secoundaryShadowNetImg"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "secoundaryShadowNetImg",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.secoundaryShadowNetImg &&
                              props.errors.secoundaryShadowNetImg && (
                                <p className="text-danger">
                                  {props.errors.secoundaryShadowNetImg}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 required">
                            Top polyfilm
                          </label>
                          <div className="w-100 col">
                            <CustomSelect type="text" name="docpolyfilmStatus">
                              <option value="">Select</option>
                              <option value="Full Damaged">Full Damaged</option>
                              <option value="Not Usable">Not Usable</option>
                              <option value="Partialy Damaged">
                                Partialy Damaged
                              </option>
                              <option value="Majorly Damaged">
                                Majorly Damaged
                              </option>
                              <option value="Non Damaged">Non Damaged</option>
                            </CustomSelect>

                            {props.touched.docpolyfilmStatus &&
                              props.errors.docpolyfilmStatus && (
                                <p className="text-danger">
                                  {props.errors.docpolyfilmStatus}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Top polyfilm Image
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="docpolyfilmImg"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "docpolyfilmImg",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.docpolyfilmImg &&
                              props.errors.docpolyfilmImg && (
                                <p className="text-danger">
                                  {props.errors.docpolyfilmImg}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Universal Join Image(side went)
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="universalJoin"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "universalJoin",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.universalJoin &&
                              props.errors.universalJoin && (
                                <p className="text-danger">
                                  {props.errors.universalJoin}
                                </p>
                              )}
                          </div>
                        </div>
                        {/* 
                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3 ">
                            Secoundary shadenet pully & rope
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              type="text"
                              name="secoundaryShadenet"
                            />
                            {props.touched.secoundaryShadenet &&
                              props.errors.secoundaryShadenet && (
                                <p className="text-danger">
                                  {props.errors.secoundaryShadenet}
                                </p>
                              )}
                          </div>
                        </div> */}

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">
                            Secoundary shadenet pully & rope
                          </label>
                          <div className="w-100 col">
                            <CustomInput
                              name="secoundaryShadenet"
                              type="file"
                              onChange={(e) =>
                                props.setFieldValue(
                                  "secoundaryShadenet",
                                  e.target.files[0]
                                )
                              }
                            />
                            {props.touched.secoundaryShadenet &&
                              props.errors.secoundaryShadenet && (
                                <p className="text-danger">
                                  {props.errors.secoundaryShadenet}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="w-25 form-label col-3">Notes</label>

                          <div className="w-100 col">
                            <CustomTextArea name="notes" />
                            {props.touched.notes && props.errors.notes && (
                              <p className="text-danger">
                                {props.errors.notes}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Edit" />

                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditStructureUtilization;
